import React, { useContext } from "react";

export default props => {
  return (
    <>
      <div
        className={`afs-msm-stage ${props.id} ${
          props.hideHeader ? " hide-header" : ""
        }`}
      >
        <header className="afs-msm-stage-header">
          <div
            className="afs-msm-stage-header-image"
            style={{
              backgroundImage: `linear-gradient(to right,rgba(0, 0, 0, 0.75),rgba(0, 0, 0, 0.55),rgba(0, 0, 0, 0.35),rgba(255, 255, 255, 0.15)), url(${props.imageUrl})`
            }}
          />
          <div className="afs-msm-stage-header-text">
            <b className="afs-msm-stage-header-title">{props.title}</b>
            {props.subtitles &&
              props.subtitles.map((subtitle, index) => {
                return (
                  <div className="afs-msm-stage-header-subtitle" key={index}>
                    {subtitle}
                  </div>
                );
              })}
          </div>
        </header>
        {props.component()}
      </div>
    </>
  );
};
